<!--Navbar Start-->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark navbar-light" (window:scroll)="windowScroll()" id="navbar">
    <div class="container">
        <!-- LOGO -->
        <a class="navbar-brand logo" [ngxScrollTo]="'#home'" href="javascript: void(0)">
            <img src="assets/logos/aa_white.png" alt="" class="logo-light" height="31">
            <img src="assets/logos/aa.png" alt="" class="logo-dark" height="31">
        </a>
        <button class="navbar-toggler p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
            <i class="mdi mdi-menu"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav ml-auto navbar-center" id="mySidenav">
                <li class="nav-item" [ngClass]="{'active':currentSection === 'contac'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#contac'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Contacto</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'services'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#services'" href="javascript: void(0)" class="nav-link" [ngxScrollToOffset]="2">Servicios</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'about'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#about'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Acerca de Nosotros</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'features'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#features'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Equipo</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'clients'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#clients'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Clientes</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'projects'}" (click)="toggleMenu()">
                    <a [ngxScrollTo]="'#projects'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Proyectos</a>
                </li>
            </ul>
            <div class="call-no">
                <a href="tel:+50664845946" class="nav-link text-warning"><i class="mdi mdi-phone mr-1"></i>Llamar</a>
            </div>            
        </div>
    </div>
</nav>
<!-- Navbar End -->

<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)" >
<!-- Hero Start -->
<section class="hero-2-bg position-relative d-flex align-items-center bg-gradient-primary" id="home">
    <div class="hero-2-bg-overlay"></div>
    <div class="container">
        <div class="hero-2-content">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="hero-2-title pr-lg-5">
                        <img src="assets/logos/aa.png" alt="" class="logo-dark" height="81">
                        <h1 class="hero-2-title text-white mb-4 font-weight-normal line-height-1_4">Diseño, Desarrollo e Implemetación</h1>
                        <p class="text-white-70 font-weight-light f-18 line-height-1_6 mb-5 ">Soluciones tecnológicas para las necesidades actuales</p>
                        <a href="tel:+50664845946" class="btn btn-warning mr-lg-2"><i class="mdi mdi-phone mr-2"></i>Llamar</a>
                        <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="0" href="javascript: void(0)">Contactanos</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mt-5 mt-lg-0">
                        <img src="assets/images/hero-2-img.png" alt="" class="img-fluid d-block mx-auto">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="hero-bottom-img">
        <img src="assets/images/hero-2-shape.png" alt="" class="img-fluid d-block w-100 mx-auto">
    </div>
</section>
    <!-- Hero End -->
    <app-services></app-services>
    <app-about></app-about>
    <app-features></app-features>
    <app-projects></app-projects>
    <app-banner></app-banner>
    <app-clients></app-clients>
    <app-contact></app-contact>
    <app-footer></app-footer>

</div>
